import Main from './main';
import Edit from './edit';
import Single from './single';
import New from './new';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit/view',
    Component: Edit,
    props: {
      exact: true,
      isView: true,
    },
  },
  {
    path: '/:id/new',
    Component: New,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
